import useSWR from 'swr';
const useSwr = ({
  url,
  fetcher,
  initialData,
  dedupingInterval = 100,
  revalidateIfStale = false,
  revalidateOnMount = true,
  ...payload
}) => {
  const urlWithPayload = [url];
  Object.values(payload).map((item) => urlWithPayload.push(item));
  const { data, isLoading } = useSWR(urlWithPayload, fetcher, {
    dedupingInterval,
    initialData,
    revalidateIfStale,
    revalidateOnMount,
  });
  return { data: data?.entity, isLoading };
};
export default useSwr;